import React, {useState, useRef, useCallback} from "react";
import {PreventNavigationContext, PreventNavigationProps, SaveCallback} from "./prevent-navigation-context-props.ts";

const PreventNavigationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [navigationPrevented, setIsNavigationPrevented] = useState(false);
    
    const saveCallback = useRef<SaveCallback | undefined>(undefined);
    
    const callSaveCallback = useCallback(async (): Promise<boolean> => {
        if (saveCallback.current) {
            try {
                const result = await saveCallback.current();
                const isSuccess = result !== false;
                if (isSuccess) {
                    saveCallback.current = undefined;
                }
                return isSuccess;
            } catch (error) {
                console.error("Save callback error:", error);
                return false;
            }
        }

        return true;
    }, []);

    const setSaveCallback = useCallback((callback?: SaveCallback) => {
        saveCallback.current = callback;
    }, []);

    const contextProps: PreventNavigationProps = {
        navigationPrevented,
        setIsNavigationPrevented,
        
        hasSaveCallback: !!saveCallback.current,
        callSaveCallback,
        setSaveCallback
    };

    return (
        <PreventNavigationContext.Provider value={contextProps}>
            {children}
        </PreventNavigationContext.Provider>
    );
}

export default PreventNavigationProvider;